import axios from 'axios';
import config from '@/config/constants';
import {getBadgeForUser} from '@/util/badge';
import {firestore} from "@/config/firebase";
// const moment = require('moment');

export default {
  namespaced: true,
  state: {
    status: '',
    tenant_id: null,
    user_id: null,
    users: [],
    receptors: [],
    vendors: [],
    agents: [],
    clients: [],
    total_receptors: 0,
    total_contacts: 0,
    notification: null,
    user: JSON.parse(localStorage.getItem(config.token_key)),
  },
  mutations: {
    tenant(state, id) {
      state.tenant_id = id;
    },
    loading(state) {
      state.status = 'loading';
    },
    success(state) {
      state.status = '';
    },
    status(state, status) {
      state.status = status;
    },
    set_tenant(state, id) {
      state.tenant_id = id;
    },
    set_user_id(state, id) {
      state.user_id = id;
    },
    set_total_receptors(state, number) {
      state.total_receptors = number;
    },
    set_total_agents(state, number) {
      state.total_agents = number;
    },
    set_total_clients(state, number) {
      state.total_clients = number;
    },
    set_total_vendors(state, number) {
      state.total_vendors = number;
    },
    set_receptors(state, data) {
      state.receptors = [];
      for (const prop in data) {
        state.receptors.push(data [prop]);
      }
    },
    set_vendors(state, data) {
      state.vendors = [];
      for (const prop in data) {
        if (data[prop]['user_role'] === 'vendor') {
          if (data[prop]['first_name']) {
            let formatted = data[prop];
            formatted['name'] = data[prop]['first_name'] + " " + data[prop]['last_name'];
            state.vendors.push(formatted);
          }

        }
      }

    },
    set_agents(state, data) {
      state.agents = [];
      for (const prop in data) {
        if (data[prop]['user_role'] === 'agent') {
          if (data[prop]['first_name']) {
            let formatted = data[prop];
            formatted['name'] = data[prop]['first_name'] + " " + data[prop]['last_name'];
            state.agents.push(formatted);
          }

        }
      }


    },
    set_clients(state, data) {
      state.clients = [];
      let agent_ids = [];
      for (const prop in data) {
        if (data[prop]['user_role'] === 'client') {
          if (!agent_ids.includes(data[prop]['invited_by_agent'])) {
            agent_ids.push(data[prop]['invited_by_agent']);
          }
        }
      }
      let agent_key = {};
      for (let agent_id of agent_ids) {
        for (const prop in data) {
          if (data[prop]['user_role'] === 'agent') {
            if (data[prop]['first_name']) {
              if (agent_id === data[prop]['owner_id']) {
                agent_key[agent_id] = data[prop]['first_name'] + " " + data[prop]['last_name'] + " Clients";
              }

            }
          }
        }
      }
      for (let agent_id of agent_ids) {
        let clients_of_agent = []
        for (const prop in data) {
          if (data[prop]['user_role'] === 'client') {
            if (data[prop]['first_name']) {
              if (data[prop]['invited_by_agent'] == agent_id) {
                clients_of_agent.push(data[prop]['owner_id'])
              }
            }
          }
        }
        let formatted_all = {
          "owner_id": clients_of_agent
        };
        formatted_all['name'] = agent_key[agent_id];
        formatted_all['group'] = agent_key[agent_id];
        state.clients.push({divider: true})

        state.clients.push(formatted_all);
        for (const prop in data) {
          if (data[prop]['user_role'] === 'client') {
            if (data[prop]['first_name']) {
              if (data[prop]['invited_by_agent'] == agent_id) {
                let formatted = data[prop];

                formatted['name'] = data[prop]['first_name'] + " " + data[prop]['last_name'];
                formatted['group'] = agent_key[agent_id];
                state.clients.push(formatted);
              }
            }
          }
        }
        // state.clients.push({ divider: true })

      }
    },
    set_users(state, data) {
      let user_current = JSON.parse(localStorage.getItem(config.token_key));
      if (user_current.user_role === 'super_user') {
        let formatted = {};
        formatted['name'] = user_current.first_name + " " + user_current.last_name;
        formatted['owner_id'] = user_current.owner_id
        state.users.push(formatted);

      } else {
        let formatted_a = {};
        formatted_a['header'] = 'Agents';
        state.users.push(formatted_a);
        for (const prop in data) {
          if (data[prop]['user_role'] === 'agent') {
            let formatted = data[prop];
            formatted['name'] = data[prop]['first_name'] + " " + data[prop]['last_name'];
            formatted['group'] = 'Agents';
            state.users.push(formatted);
          }
        }
        let formatted_v = {};
        formatted_v['header'] = 'Vendors';
        state.users.push(formatted_v);
        for (const prop in data) {
          if (data[prop]['user_role'] !== 'agent') {
            let formatted = data[prop];
            formatted['name'] = data[prop]['first_name'] + " " + data[prop]['last_name'];
            formatted['group'] = 'Vendors';
            state.users.push(formatted);
          }
        }
      }


    },
    save_notification(state, data) {
      state.notification = data;
      state.total_contacts = data.total_contacts
    },

  },
  actions: {
    get_tenant: async function ({commit}) {
      return new Promise(function (resolve) {
        try {
          axios.post(config.api_url + 'web/retrieve_logged').then(async response => {
            let data = response.data;
            if (data['code'] === "SUCCESS") {
              await commit('set_tenant', data['tenant_id']);
              await commit('set_user_id', data['user_id']);
            }
            resolve('success');
          });

        } catch (error) {
          console.error(error);
          resolve('error');
        }
      });
    },
    query({commit, state}, data) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        try {
          let db = firestore;
          const usersRef = db
            .collection('tenants')
            .doc(state.tenant_id)
            .collection("users");
          const idParam1 = usersRef.where('user_role', '==', data.param1).get();
          const idParam2 = usersRef.where('user_role', '==', data.param2).get();

          const [Param1QuerySnapshot, Param2QuerySnapshot] = await
            Promise.all([
              idParam1,
              idParam2
            ]);

          const Param1Array = Param1QuerySnapshot.docs;
          const Param2Array = Param2QuerySnapshot.docs;

          const usersArray = Param1Array.concat(Param2Array);
          const users = [];
          for (const user of usersArray) {
            // eslint-disable-next-line no-undef
            let query = await db.collection('users').doc(user.data()['owner_id']).get();

            let user_global = query.data();
            let user_details = user.data();
            user_details['id'] = user.id;

            for (let key in user_global) {
              user_details[key] = user_global[key];
            }

            users.push(user_details);
          }
          resolve(users);

        } catch (error) {
          console.error(error);
          commit('status', '');

        }
      });
    },
    query_users({commit, state}, data) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        try {
          let db = firestore;
          const usersRef = db
            .collection('tenants')
            .doc(state.tenant_id)
            .collection("users");

          const idParam1 = usersRef.where('user_role', '==', data.param1).where('is_active', '==', true).get();
          const idParam2 = usersRef.where('user_role', '==', data.param2).where('is_active', '==', true).get();
          const idParam3 = usersRef.where('user_role', '==', data.param3).where('is_active', '==', true).get();

          const [Param1QuerySnapshot, Param2QuerySnapshot, Param3QuerySnapshot] = await
            Promise.all([
              idParam1,
              idParam2,
              idParam3
            ]);

          const Param1Array = Param1QuerySnapshot.docs;
          const Param2Array = Param2QuerySnapshot.docs;
          const Param3Array = Param3QuerySnapshot.docs;


          const usersArray = Param1Array.concat(Param2Array, Param3Array);
          const users = [];

          // Collect distinct owner_ids from tenant-user docs.
          // Antes hacíamos un scan completo de /users con orderBy('first_name'),
          // que silenciosamente SKIPea cualquier doc sin first_name — esos usuarios
          // perdían su device_tokens y nunca recibían la push. Ahora hacemos getAll
          // por las refs específicas para no depender de campos opcionales.
          const ownerIdsSet = new Set();
          for (const user of usersArray) {
            const ownerId = user.data()['owner_id'];
            if (ownerId) ownerIdsSet.add(ownerId);
          }
          const ownerIds = Array.from(ownerIdsSet);

          // Build DocumentReference array and fetch in chunks of 100.
          // Firebase compat: db.getAll(...refs) may not be exposed on the
          // Firestore instance — fall back to Promise.all(refs.map(r => r.get()))
          // which is equivalent semantically (just less efficient).
          const refs = ownerIds.map(id => db.collection('users').doc(id));
          const globalDocs = [];
          const CHUNK_SIZE = 100;
          for (let i = 0; i < refs.length; i += CHUNK_SIZE) {
            const chunk = refs.slice(i, i + CHUNK_SIZE);
            let snapshots;
            if (typeof db.getAll === 'function') {
              snapshots = await db.getAll(...chunk);
            } else {
              snapshots = await Promise.all(chunk.map(ref => ref.get()));
            }
            for (const snap of snapshots) {
              if (snap && snap.exists) globalDocs.push(snap);
            }
          }

          // Map<ownerId, globalData> built only from existing docs.
          const globalById = new Map();
          for (const doc of globalDocs) {
            globalById.set(doc.id, doc.data());
          }

          // Merge global fields into each tenant-user doc.
          for (const user of usersArray) {
            const user_details = user.data();
            user_details['id'] = user.id;
            const user_global = globalById.get(user_details['owner_id']);
            if (user_global) {
              for (let key in user_global) {
                user_details[key] = user_global[key];
              }
            }
            users.push(user_details);
          }

          users.sort((a, b) => {
            const an = (a.first_name || '').toLowerCase();
            const bn = (b.first_name || '').toLowerCase();
            if (an < bn) {
              return -1;
            }
            if (an > bn) {
              return 1;
            }
            return 0;
          });


          resolve(users);

        } catch (error) {
          console.error(error);
          commit('status', '');

        }
      });
    },
    async retrieve_receptors({commit, dispatch}) {
      commit('loading');
      await dispatch('query_users', {
        param1: 'agent',
        param2: 'client',
        param3: 'vendor'
      }).then(receptors => {
        let number_clients = 0;
        let number_vendors = 0;
        let number_agents = 0;
        for (const user of receptors) {
          if (user.first_name) {
            if (user.user_role === 'agent') {
              number_agents += 1;
            }
            if (user.user_role === 'client') {
              number_clients += 1;
            }
            if (user.user_role === 'vendor') {
              number_vendors += 1;
            }
          }
        }

        commit('set_total_agents', number_agents);
        commit('set_total_clients', number_clients);
        commit('set_total_vendors', number_vendors);
        commit('set_total_receptors', receptors.length - 1);
        commit('set_receptors', receptors);
        commit('set_vendors', receptors);
        commit('set_agents', receptors);
        commit('set_clients', receptors);
        commit('success');
      }).catch(err => {
        commit('status', '');
        console.error(err);
      });

    },
    async retrieve_users({commit, dispatch}) {
      commit('loading');
      await dispatch('query', {
        param1: 'agent',
        param2: 'vendor'
      }).then(users => {
        commit('set_users', users);
        commit('success');
      }).catch(err => {
        commit('status', '');
        console.error(err);
      });

    },
    get_chat: function ({state}, participants) {
      let participants_url = [];
      participants_url.push("/tenants/" + state.tenant_id + "/users/" + participants['sender']);
      participants_url.push("/tenants/" + state.tenant_id + "/users/" + participants['receptor']);

      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        let database = firestore;
        database
          .collection("tenants")
          .doc(state.tenant_id)
          .collection("chats")
          .where("participant_ids", "==", participants_url)
          .limit(1)
          .get()
          .then((data1) => {
            let chat_id = null;
            data1.forEach((doc) => {
              chat_id = doc.id;
            });
            resolve(chat_id);
          })
          .catch((error) => {
            console.error(error);
          });
      });
    },
    send_notification: function ({commit, state}) {
      commit('loading');
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        const sentToSet = new Set();
        for (const vendor of state.notification.selected_vendors) sentToSet.add(vendor);
        for (const agent of state.notification.selected_agents) sentToSet.add(agent);
        for (const client of state.notification.selected_clients) {
          if (client !== undefined && !Array.isArray(client)) sentToSet.add(client);
        }
        const sent_to = Array.from(sentToSet);

        const senderUserId = state.notification['user'] && state.notification['user']['owner_id'];
        // recipients_targeted excluye al sender si está dentro del set seleccionado
        let recipients_targeted = sentToSet.size;
        if (senderUserId && sentToSet.has(senderUserId)) {
          recipients_targeted -= 1;
        }
        let recipients_with_devices = 0;

        // Wire format: { common, recipients }. Sólo token / owner_id / badge varían
        // por receptor; el resto del payload (notification, data, android, apns) es
        // idéntico para todo el envío y va una sola vez en `common`. A 1000
        // recipientes esto reduce el body de ~700KB a ~140KB.
        const recipients_payload = [];
        let common_payload = null;
        // El backend persiste el `alert` (Firestore rules deny writes desde
        // el cliente). El doc ID generado server-side se inyecta en cada
        // FCM `data.notification_id` antes de enviar.
        let alert_payload = null;

        if (sent_to.length > 0) {
          const text_notification = state.notification.text;
          alert_payload = {
            title: state.notification.title,
            text: text_notification,
            data: {
              type: 'start_chat',
              user_id: senderUserId
            },
            tenant_id: state.tenant_id,
            user_ids: sent_to
          };

          common_payload = {
            notification: {
              title: state.notification.title,
              body: text_notification
            },
            data: {
              type: 'start_chat',
              user_id: senderUserId,
              tenant_id: state.tenant_id,
              title: state.notification.title,
              body: text_notification
              // notification_id lo stampa el backend con el id del doc /alerts
              // badge se inyecta per-recipient en el backend desde recipients[].badge
            },
            android: {
              priority: "high",
              notification: {
                sound: "default"
              }
            },
            apns: {
              payload: {
                aps: {
                  sound: "default"
                  // badge igual: se inyecta per-recipient
                }
              }
            }
          };

          for (const receptor of state.receptors) {
            if (!sentToSet.has(receptor.owner_id)) continue;
            if (senderUserId === receptor.owner_id) continue;

            // receptor already has merged users/{id} fields incl. device_tokens
            // and tenant_badge (synced by updateUserBadgeFromNotifications trigger).
            // getBadgeForUser fires its notifications/{id} write without await,
            // so this loop stays sync and the writes parallelize.
            const unread_messages = getBadgeForUser(receptor, {type: "alert", tenant_id: state.tenant_id});

            // Filtrar tokens corruptos (strings vacíos, null, no-string) que el
            // backend rechazaría. device_tokens debería ser siempre array de strings
            // (lo escribe arrayUnion en register_device_token), pero algunos docs
            // tienen entradas inválidas; el backend además limpia esto cuando llega.
            const rawTokens = Array.isArray(receptor.device_tokens) ? receptor.device_tokens : [];
            const tokens = rawTokens.filter(t => typeof t === 'string' && t.length > 0);
            if (tokens.length > 0) {
              recipients_with_devices += 1;
            }
            for (const t in tokens) {
              recipients_payload.push({
                token: tokens[t],
                // owner_id viaja al backend para que pueda limpiar tokens stale o inválidos
                owner_id: receptor.owner_id,
                badge: unread_messages
              });
            }
          }
        }

        // Pre-flight: si no hay nada que enviar, no POSTeamos (evitamos 400 del backend).
        if (recipients_payload.length === 0) {
          commit('success');
          resolve({status: 'no_devices', recipients_targeted: recipients_targeted});
          return;
        }

        try {
          const resp = await axios.post(config.api_url + 'send_push_notifications_clients', {
            common: common_payload,
            recipients: recipients_payload,
            alert: alert_payload
          });
          commit('success');
          resolve({
            status: 'success',
            summary: (resp.data && resp.data.summary) || null,
            recipients_targeted: recipients_targeted,
            recipients_with_devices: recipients_with_devices
          });
        } catch (err) {
          commit('status', '');
          const status = err.response && err.response.status;
          const backendMsg = err.response && err.response.data && (err.response.data.error || err.response.data.message);
          console.error('send_push_notifications_clients failed', err);
          resolve({
            status: 'error',
            http_status: status || null,
            error: backendMsg || err.message || 'Failed to send'
          });
        }
      });
    }
  },
  getters: {
    receptors_with_devices_count: (state) => {
      return state.receptors.filter(r => Array.isArray(r.device_tokens) && r.device_tokens.length > 0).length;
    }
  },
  modules: {}
  ,
}
;
